
riot.tag2('sms-journal', '  <catalog search="true" sortable="true" object="SmsLog" cols="{cols}" reload="true" store="sms-log">\n    <yield to="body">\n      <datatable-cell name="date">{row.date}</datatable-cell>\n      <datatable-cell name="phone">{row.phone}</datatable-cell>\n      <datatable-cell name="userName">{row.userName}</datatable-cell>\n      <datatable-cell name="text">{row.text}</datatable-cell>\n      <datatable-cell name="cost">{row.cost}</datatable-cell>\n      <datatable-cell name="count">{row.count}</datatable-cell>\n      <datatable-cell name="provider">{row.provider}</datatable-cell>\n      <datatable-cell name="status">{row.status}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.cols = [{ name: 'date', value: 'Время' }, { name: 'phone', value: 'Телефон' }, { name: 'userName', value: 'Пользователь' }, { name: 'text', value: 'Текст' }, { name: 'cost', value: 'Стоимость' }, { name: 'count', value: 'Кол-во' }, { name: 'provider', value: 'Провайдер' }, { name: 'status', value: 'Статус' }];

observable.on('sms-reload', function () {
    return self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/settings/sms/sms-journal.tag